import { useEffect, useRef, useState } from 'react';
import ArticleList from 'ui/components/molecules/ArticleList';
import StaticPagination from '../../atoms/StaticPagination';
import Tabs from '../../atoms/Tabs';
import pageViewNews from 'ui/lib/gtm/pageViewNews';
import { sendDataInChunks } from 'ui/lib/collectData';
import pageKey from '../../../constants/pageKey';
import useImpressionNewsList from '../../../hooks/emarsys/news/useImpressionNewsList';

const ArticleListTabSection = ({
  header,
  itemList,
  categoryType,
  totalData,
  totalPages,
  pageSize,
  paginationBaseUrl,
  newsHero,
  tabClassname,
  feature = '',
  emarsysData = {
    pageTitle: '',
    category: '',
    page_number: 0,
  },
}) => {
  const impressionRef = useRef(null);
  const [collectDataLayer, setCollectDataLayer] = useState([]);

  useEffect(() => {
    if (collectDataLayer?.length > 0) {
      sendDataInChunks(
        collectDataLayer,
        1,
        (chunk) => {
          pageViewNews(chunk);
        },
        setCollectDataLayer,
        ''
      );
    }
  }, [collectDataLayer]);

  if (feature === 'NEWS_LIST') {
    useImpressionNewsList(
      impressionRef,
      emarsysData?.pageTitle,
      emarsysData?.category,
      emarsysData?.page_number,
      'list berita'
    );
  }

  return (
    <section className="lg:my-[20px]" ref={impressionRef}>
      <div className="lg:container xl:px-0">
        <div className={`container lg:p-0`}>
          <h1 className="text-base font-bold uppercase text-reliableBlack lg:text-2xl">
            {header.title}
          </h1>
          <p className="text-xs font-medium leading-relaxed text-reliableBlack lg:text-base">
            {header.content}
          </p>
        </div>
        <div className="lg:my-2">
          <Tabs
            tabs={categoryType}
            tabClassname={tabClassname}
            from={pageKey.newsTips}
            emarsysData={{
              category: emarsysData.category,
              title: emarsysData.pageTitle,
              page_number: emarsysData.page_number,
            }}
            feature={feature}
          >
            <div
              className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 lg:gap-x-6 lg:gap-y-8  ${
                !newsHero ? 'lg:mt-8' : ''
              }`}
            >
              <ArticleList
                handleCollectDataLayer={(data) => setCollectDataLayer((prev) => [...prev, data])}
                articles={itemList}
                newsHero={newsHero}
                showTag
                valueMarginRoot={''}
                feature={feature}
                emarsysData={emarsysData}
              />
            </div>
          </Tabs>

          {/* Pagination */}
          <div className="flex items-center justify-center mt-6 lg:mt-9 lg:justify-between">
            <p className="hidden items-center gap-1 text-lg lg:flex">
              <span>Menampilkan</span>
              <span className="font-semibold">{itemList.length}</span>
              <span>dari</span>
              <span className="font-semibold">{totalData}</span>
            </p>

            <StaticPagination
              totalCount={totalData}
              totalPages={totalPages}
              pageSize={pageSize}
              paginationBaseUrl={paginationBaseUrl}
              feature={feature}
              emarsysData={emarsysData}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArticleListTabSection;
